<template>
  <div class="register">
    <img src="../assets/image/register.png"/>
    <div class="center">
      <van-form @submit="submit">
        <van-field
            v-model="form.nickName"
            name="姓名"
            label="姓名"
            placeholder="请填写姓名"
            :rules="[{ required: true }]"
        />
        <van-field
            v-model="form.phone"
            name="手机号"
            label="手机号"
            placeholder="请输入手机号"
            :rules="[{ required: true }]"
        />
        <van-field
            v-model="form.code"
            name="验证码"
            label="验证码"
            placeholder="请输入验证码"
            :rules="[{ required: true }]">
          <van-button class="sendCode" :disabled="disabled" slot="button" size="small" native-type="button" @click="sendCode">
            <span style="font-size:12px;"> {{num }}</span>
          </van-button>
        </van-field>
        <div style="margin: 16px;">
          <van-button class="search" round block type="info" native-type="submit">报告查询</van-button>
        </div>
      </van-form>
    </div>
    <div class="notice">
      本次查询仅针对有证件号码，手机号登记的个人客户，医院及单位团体送检的请按原定方式咨询！
    </div>
  </div>
</template>

<script>

import {getRegister, getCode} from '@/api/order/index.js';

export default {
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#F4F4F4');
  },
  name: "register.vue",
  data() {
    return {
      num: '获取验证码',
      form: {
        nickName: '',
        phone: '',
        code: ''
      },
      disabled:false
    };
  },
  created() {

  },
  methods: {
    sendCode() {
      this.num =120;
      var timer = setInterval(() => {
        this.num--;
        this.disabled=true;
        if (this.num === 0) {
          this.num = '获取验证码';
          this.disabled=false;
          clearInterval(timer);
        }

      }, 1000);

      const data = {
        phone: this.form.phone,
        nickName:this.form.nickName
      };
      getCode(data).then(res => {
        console.log(res);
        //如果成功
        if (res.data.code === 200) {
          this.form = res.data.data[0];
          //告诉用户已发送验证码
          this.$toast(res.data.msg);
        } else {
          //如果客户没预约等等原因
          this.$toast(res.data.msg);
          //清除倒计时
          this.num = '获取验证码';
          clearInterval(timer);
        }

      });
    },
    submit() {
      const data = {
        phone: this.form.phone,
        nickName: this.form.nickName,
        code: this.form.code
      };
      getRegister(data).then(res => {
        //如果成功
        if (res.data.code === 200) {
          //判断后端是否返回 检测报告
          if (res.data.data[0]) {
            // 如果返回了 就赋值并跳转页面
            this.form.result = res.data.data[0].result;
            this.form.name = res.data.data[0].name;
            this.form.createTime = res.data.data[0].createTime;
            this.$router.push({path: 'port', query: {result: this.form.result, name: this.form.name,createTime:this.form.createTime}});

          } else {
            this.$toast(`暂时没有检测报告!`);
          }

        } else {
          //如果客户没预约等等原因
          this.$toast(res.data.msg);
        }


        // console.log(this.form.result);
      });
    }
  }
};
</script>

<style scoped lang='less'>
.register {
  width: 750px;
}

img {
  width: 100%;
}

.center {
  width: 750px;
  height: 590px;
  background-color: #fff;
  padding: 50px 50px;
  box-sizing: border-box;
  margin-top: 20px;

  .van-cell {
    height: 100px;
    align-items: center;
    font-size: 32px;
    justify-content: space-around;
    font-weight: 600;

    .van-cell__value {
      font-size: 28px;
      color: #919191;
      height: 28px;
      flex: 2;
    }
  }

  .search {
    height: 80px;
    background-color: #48BB9C;
    border: none;
    font-size: 32px;
    margin-top: 70px;
  }
}

.notice {
  width: 639px;
  font-size: 28px;
  margin: 30px auto;
  color: #BA0000;
  line-height: 40px;
}

.sendCode {
  border: 1px solid #48BB9C;
  height: 64px;
  width: 180px;
  border-radius: 32px;
  color: #48BB9C;

}

</style>
